/* global $ */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalUserMediaError.css';
import * as telemedicinaAction from '../../../actions/telemedicinaActions';
import { LOCALSTORAGE_AUTH_KEY } from '../../../constants/index';
import generateAbsoluteUrl from '../../../utils/generateAbsoluteUrl';
import redirectTo from '../../../utils/redirectTo';

class ModalUserMediaError extends Component {
  constructor(props) {
    super(props);
    this.hideModalVideoLlamada = this.hideModalVideoLlamada.bind(this);
    this.finalizar = this.finalizar.bind(this);
  }

  finalizar() {
    this.props.cleanLlamada();
    if (
      document.getElementById('localView') &&
      document.getElementById('localView').srcObject
    ) {
      document
        .getElementById('localView')
        .srcObject.getTracks()
        .forEach(track => track.stop());
      $('localView').srcObject = null;
    }
    const datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
    const token = datos.token;
    const dataToken = {
      token,
    };
    $.ajax({
      url: `${generateAbsoluteUrl()}/renew-token`,
      global: false,
      type: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(dataToken),
      async: false,
      success: response => {
        if (response.data && response.data.token && response.data.exp) {
          const authData = localStorage.getItem(LOCALSTORAGE_AUTH_KEY);
          const authJson = JSON.parse(authData);
          authJson.token = response.data.token;
          authJson.exp = response.data.exp;
          localStorage.setItem('token', JSON.stringify(authJson.token));
          localStorage.setItem(LOCALSTORAGE_AUTH_KEY, JSON.stringify(authJson));
        }
      },
    });
    this.props.hideValidacionesTecnicas();
    redirectTo('/telemedicina');
  }

  hideModalVideoLlamada() {
    if(this.props.llamadaIniciada){
      document
      .getElementById('localView')
      .srcObject.getTracks()
      .forEach(track => track.stop());
      $('localView').srcObject = null;
    }
    
    $('#estudiosIcon').popover('hide');
    $('#modalVideoLlamada').fadeOut(200);
    $('#modalUserMediaError').modal('hide');
    this.finalizar();
  }

  componentDidMount(){
    $('#modalUserMediaError').modal('show');
    //setTimeout(() => { $('#boton_salir_id').trigger('click') }, 3000);
    setTimeout(() => { this.hideModalVideoLlamada() }, 3000);
  }

  render() {
    return (
      <div className="modal fade" id="modalUserMediaError">
        <div className="modal-dialog">
          <div className={`${s.modalContent} modal-content`}>
            <div className="modal-header">
              <h5 className="modal-title">Error de Videollamada</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className={`${s.modalBody} modal-body`}>
              <div>La comunicación por videollamada no podrá ser realizada en este momento debido a problemas en los periféricos de Audio y/o Video de su equipo. Verifique de cerrar programas que puedan estar consumiendo los mismos para poder establecer una comunicación por videollamada exitosa.</div>
            </div>
            <div className={`${s.modalFooter} modal-footer`}>
              <button
                id="boton_salir_id"
                data-dismiss="modal"
                className={`${s.boton_rojo} btn btn-danger`}
                onClick={() => {
                  this.hideModalVideoLlamada();
                }}
              >
                Salir
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, telemedicinaAction)( withStyles(s)(ModalUserMediaError));



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalUserMediaError/ModalUserMediaError.js